module.exports = __webpack_public_path__ + "img/33.9bf7942b.jpg";